enum DiscountImageType {
  banner = 1,
}

export default DiscountImageType;
